var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"per-page-select",attrs:{"label":"Rows per page","items":_vm.options,"value":_vm.currentPerPageCount},on:{"change":_vm.setCountPerPage}})}
var staticRenderFns = []

export { render, staticRenderFns }